__turbopack_context__.v({
  "icon": "ProductValueProposition-module-scss-module__riIpUq__icon",
  "iconWithText": "ProductValueProposition-module-scss-module__riIpUq__iconWithText",
  "valuePropContainer": "ProductValueProposition-module-scss-module__riIpUq__valuePropContainer",
  "valuePropIcon": "ProductValueProposition-module-scss-module__riIpUq__valuePropIcon",
  "valuePropLink": "ProductValueProposition-module-scss-module__riIpUq__valuePropLink",
  "valuePropTitle": "ProductValueProposition-module-scss-module__riIpUq__valuePropTitle",
});
